<template>
  <div v-if="savedFilters?.items" class="catalog-saved-filters">
    <DefRadio
      v-for="item in savedFilters?.items"
      name="filter"
      :checked="item.UF_FILTER_URL === savedFilters.filterUrl"
      @change="handlerChange(item)"
    >
      {{ item?.UF_NAME }}
    </DefRadio>
  </div>
</template>

<script lang="ts" setup>
import { useStore } from '@/store';
import { computed } from 'vue';
import DefRadio from '@components/Def/DefRadio/DefRadio.vue';

const { state, dispatch } = useStore();

const savedFilters = computed(() => state.catalog?.data?.catalogSmartFilter?.savedFilters);

const handlerChange = (item) => {
  if (item.UF_FILTER_URL) {
    dispatch('catalog/changePageData', item.UF_FILTER_URL);
  }
};
</script>

<style lang="scss" scoped>
.catalog-saved-filters {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  grid-row-gap: 16px;
}
</style>
